var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_245_362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_245_362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -2.5,
    width: 81.25,
    height: 86.25,
    fill: "#E3E3E3",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2126 53.7082C36.0477 56.2167 40.2287 56.1869 40.2362 56.1869C40.2437 56.1869 44.4253 56.2167 46.2594 53.7082C48.057 51.25 50.3695 46.811 50.6212 43.8053C50.8714 40.8001 50.1613 36.3564 48.6807 34.5127C45.9043 31.0534 40.2437 31.0679 40.2362 31.0679C40.2287 31.0679 34.5681 31.0534 31.7912 34.5127C30.3106 36.3564 29.6006 40.8001 29.8512 43.8053C30.1029 46.811 32.4154 51.25 34.2126 53.7082Z",
    fill: "#8D9091",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3771 75.3925C63.1816 73.1514 62.8296 70.2998 62.1866 67.3012C61.2348 62.8621 59.3113 58.8941 56.7323 57.4054C53.3652 55.4599 50.3839 54.4026 48.3411 53.8344C48.3053 53.9323 48.2655 54.0598 48.2302 54.1535C45.7721 60.8355 40.7167 61.028 40.1478 61.028C40.1453 61.028 40.1428 61.028 40.1403 61.028C40.1378 61.028 40.1353 61.028 40.1328 61.028C39.5644 61.028 34.5085 60.8355 32.0504 54.1535C32.0156 54.0598 31.9758 53.9323 31.9395 53.8344C29.8967 54.4035 26.9154 55.4607 23.5483 57.4054C20.9704 58.8941 19.0468 62.8629 18.095 67.3012C17.452 70.2998 17.1005 73.1514 16.905 75.3925C16.8687 75.8223 16.8374 76.2251 16.811 76.606C16.8618 78.4916 17.7713 79.9997 18.8947 79.9997H40.1408H61.3869C62.5108 79.9997 63.4203 78.4924 63.4706 76.606C63.4437 76.226 63.4129 75.8223 63.3771 75.3925Z",
    fill: "#8D9091",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profile-pic.de2615734eaa196045ecf0add78380d9.svg";
export { ForwardRef as ReactComponent };